"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const paymentbrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-paymentbrand03` : '') + (description ? ` desc-paymentbrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-paymentbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-paymentbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.727 5.294c4.677.012 8.466 3.476 8.478 7.754v28.429c-.012 4.277-3.801 7.741-8.478 7.753h-8.478l.121-.319h-.122v8.072c.126 1.914-.779 3.764-2.423 4.954-1.644 1.19-3.82 1.572-5.828 1.021l-31.528-6.781c-4.73-1.192-8.073-5.047-8.263-9.532V13.048c.007-2.022.857-3.862 2.245-5.242l.043-.042 1.948.45v-.006l-1.948-.444.12-.115c1.54-1.447 3.69-2.348 6.07-2.355h48.043Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.889.698h47.896c5.133.013 9.435 3.854 9.449 8.768v28.499c-.014 4.914-4.316 8.756-9.449 8.768h-7.454v6.74c.136 2.27-.939 4.43-2.827 5.805-1.884 1.372-4.357 1.806-6.636 1.187L9.465 53.673a1.307 1.307 0 0 1-.034-.008C4.335 52.375.65 48.17.44 43.185a1 1 0 0 1-.001-.042V9.466c.007-2.261.922-4.295 2.408-5.833a1 1 0 0 1 .323-.319C4.896 1.697 7.285.705 9.89.698ZM4.057 5.276C3.044 6.44 2.445 7.904 2.44 9.471v33.65c.177 3.992 3.147 7.5 7.466 8.601l31.41 6.794a.911.911 0 0 1 .055.013c1.717.473 3.57.14 4.956-.868 1.38-1.005 2.107-2.537 2.006-4.092a.936.936 0 0 1-.002-.065V22.443c-.18-4.005-3.122-7.537-7.43-8.709L4.058 5.276ZM50.33 44.733V22.378c-.214-4.982-3.851-9.208-8.925-10.58a1.123 1.123 0 0 0-.038-.009L6.041 3.68a7.986 7.986 0 0 1 3.852-.98H57.78c4.192.01 7.442 3.113 7.453 6.772v28.49c-.011 3.659-3.261 6.761-7.452 6.772H50.33Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.805 9.469a1 1 0 0 1 1-1h28.172a1 1 0 1 1 0 2H26.806a1 1 0 0 1-1-1ZM31.491 35.372c0-3.423 2.8-6.18 6.233-6.18 3.432 0 6.232 2.757 6.232 6.18 0 3.423-2.8 6.18-6.232 6.18-3.433 0-6.233-2.757-6.233-6.18Zm6.233-4.18c-2.347 0-4.233 1.88-4.233 4.18s1.886 4.18 4.233 4.18c2.347 0 4.232-1.88 4.232-4.18s-1.886-4.18-4.232-4.18ZM48.343 22.42a1 1 0 0 1 1-1h5.634a1 1 0 1 1 0 2h-5.634a1 1 0 0 1-1-1Z"
  })));
};
var _default = exports.default = paymentbrand03;